const normalizarDescricaoCargo = (descricao = "") =>
  String(descricao)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

export const operadorTemCargo = (operador, descricaoCargo) => {
  const descricaoEsperada = normalizarDescricaoCargo(descricaoCargo);

  return (operador?.cargos ?? []).some((cargo) =>
    normalizarDescricaoCargo(
      cargo?.descricao ?? cargo?.Descrição ?? cargo?.["DescriÃ§Ã£o"]
    ) === descricaoEsperada
  );
};

export const operadorEhGerente = (operador) =>
  operadorTemCargo(operador, "Gerente");

export const operadorEhAdmin = (operador) => {
  const cargos = operador?.cargos ?? [];
  if (cargos.length > 0) return operadorTemCargo(operador, "Administrador");
  return Number(operador?.permissaoPrincipal) === 99;
};

export const operadorEhAdminOuGerente = (operador) =>
  operadorEhAdmin(operador) ||
  operadorEhGerente(operador) ||
  ((operador?.cargos ?? []).length === 0 &&
    [90, 99].includes(Number(operador?.permissaoPrincipal)));

export const normalizarOperadorPorCargo = (operador) => {
  if (!operador) return operador;
  if (operadorTemCargo(operador, "Administrador")) {
    return { ...operador, permissaoPrincipal: 99 };
  }
  if (operadorTemCargo(operador, "Gerente")) {
    return { ...operador, permissaoPrincipal: 90 };
  }
  return operador;
};
